import 'react-day-picker/dist/style.css';

import { CookieConsentBanner } from './common/components/cookie-consent-banner';
import { useAnalyticsConsent } from './common/hooks/use-analytics-consent';
import { Entry as EntryCommon } from './common/views/entry';

const App = () => {
  useAnalyticsConsent();

  return (
    <>
      <EntryCommon />
      <CookieConsentBanner />
    </>
  );
};

export default App;
